export const logoutUser = () => window.open(`${globalThis.env.VITE_LEGACY_APP_URL}/logout`, '_self');
